import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { connectLocation } from '../../location/LocationConnectors';
import { ErrorP } from '../Styles';

// Five of the 64 generated locales carry errors.forms, and t returns undefined on a miss, so
// without a default the other 59 render a dead checkbox with no explanation at all.
const FALLBACKS = {
  expired: 'Verification expired. Please confirm you are not a robot again.',
  failed: 'Verification could not be completed. Please try again.',
};

const Recaptcha = ({ options, onChange, locale = {}, t }) => {
  const { code = 'en-US' } = locale;
  const widget = useRef(null);
  const [failure, setFailure] = useState(null);

  // Supplying onExpired replaces the library's own fallback, which is the only thing clearing
  // the token today, so clearing it here is not optional: recaptcha is a required field.
  const fail = key => {
    onChange(null);
    // v2 will not re-challenge after a timeout without this, so the user has no way back
    widget.current?.reset();
    setFailure(t(`errors.forms.recaptcha_${key}`, { default: FALLBACKS[key] }));
  };

  return (
    <div style={{ width: 'auto' }}>
      <ReCAPTCHA
        ref={widget}
        sitekey={options.recaptchaSiteKey}
        hl={code}
        onChange={token => {
          setFailure(null);
          onChange(token);
        }}
        onExpired={() => fail('expired')}
        onErrored={() => fail('failed')}
      />
      {failure && (
        <ErrorP className="error" role="alert">
          {failure}
        </ErrorP>
      )}
    </div>
  );
};

Recaptcha.propTypes = {
  options: PropTypes.shape({ recaptchaSiteKey: PropTypes.string }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default connectLocation(Recaptcha);
